<template>
  <v-list-item @click="action">
    <v-list-item-action>
      <v-icon color="white">{{ icon }}</v-icon>
    </v-list-item-action>
    <v-list-item-content>
      <v-list-item-title class="white--text">{{ name }}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'MenuLinkAction',
  props: {
    name: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    action: {
      type: Function,
      default: () => {}
    }
  }
}
</script>
